// extracted by mini-css-extract-plugin
export default {"mainContainer":"PrivacyPolicy_mainContainer__3GWU6","title":"PrivacyPolicy_title__dVjCb"};